module.exports = __webpack_public_path__ + "images/activity_indicator.gif";